import { useMemo } from 'react';

export const useStudentTimetablePageTitle = (
  isAdminView: boolean,
  timetable?: { studentName?: string; courseName?: string },
) =>
  useMemo(
    () => (isAdminView ? timetable?.studentName : timetable?.courseName) || '',
    [timetable, isAdminView],
  );
